module.exports = __webpack_public_path__ + "img/golf_bag.5634602c.svg";